import Cookies from 'js-cookie'
const TokenKey = 'pingxuan_pc_token'
const TidKey = 'pingxuan_pc_tid'
const IsAgreeKey = 'pingxuan_pc_isAgree'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getTid() {
    return Cookies.get(TidKey)
}

export function setTid(tid) {
    return Cookies.set(TidKey, tid)
}

export function removeTid() {
    return Cookies.remove(TidKey)
}

export function getAgreement() {
    return Cookies.get(IsAgreeKey)
}

export function setAgreement(isAgree) {
    return Cookies.set(IsAgreeKey, isAgree)
}
